module.exports = __webpack_public_path__ + "img/anxiety.a2a15f17.svg";